import React from 'react'
import { PieChart, Pie, Cell } from 'recharts'

const COLORS = ['#C6CCF4', '#8E98E4', '#5C67CA', '#434EB0', '#2F3A8F']

const RADIAN = Math.PI / 180

export const CustomPieChart = ({ data }) => {
  const chartSize = 300
  const centerX = chartSize / 2
  const centerY = chartSize / 2
  const labelRadius = centerX + 15
  const labelOffset = 8

  const total = data.reduce((sum, item) => sum + item.percentage, 0)

  let startAngle = 180
  const slices = data.map(item => {
    const angle = (item.percentage / total) * 360
    const midAngle = startAngle - angle / 2

    const x =
      centerX + (labelRadius + labelOffset) * Math.cos(-midAngle * RADIAN)
    const y =
      centerY + (labelRadius + labelOffset) * Math.sin(-midAngle * RADIAN)

    startAngle -= angle

    return {
      ...item,
      midAngle,
      x,
      y,
    }
  })

  return (
    <div
      style={{
        position: 'relative',
        width: '400px',
        background: '#F8FAFF',
        padding: '20px',
        borderRadius: '10px',
      }}
    >
      <div
        style={{
          width: `${chartSize}px`,
          height: `${chartSize}px`,
          margin: '0 auto',
          background: '#FFFFFF',
          borderRadius: '50%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          position: 'relative',
        }}
      >
        <PieChart width={chartSize} height={chartSize}>
          <Pie
            data={data}
            cx={centerX}
            cy={centerY}
            innerRadius={chartSize / 4}
            outerRadius={chartSize / 2.5}
            startAngle={180}
            endAngle={-180}
            dataKey="percentage"
            cornerRadius={10}
          >
            {data.map((entry, index) => (
              <Cell
                key={`cell-${index}`}
                fill={COLORS[index % COLORS.length]}
                stroke="#FFFFFF"
                strokeWidth={4}
              />
            ))}
          </Pie>
        </PieChart>
      </div>

      {slices.map((slice, index) => {
        const labelAlign =
          slice.midAngle < 90 && slice.midAngle > -90 ? 'left' : 'right'

        const labelX = slice.x + (labelAlign === 'left' ? 17 : -30)
        const labelY = slice.y + (slice.midAngle > 0 ? 10 : -10) //

        return (
          <div
            key={index}
            style={{
              position: 'absolute',
              left: `${labelX}px`,
              top: `${labelY}px`,
              textAlign: labelAlign,
              pointerEvents: 'none',
              width: '120px',
            }}
          >
            <div
              style={{
                color: COLORS[index],
                fontWeight: 'bold',
                fontSize: '14px',
                lineHeight: '22px',
              }}
            >
              {slice.percentage}%
            </div>
            <div
              style={{
                color: '#333333',
                fontWeight: 500,
                fontSize: '12px',
                whiteSpace: 'normal',
                wordWrap: 'break-word',
              }}
            >
              {slice.genre}
            </div>
          </div>
        )
      })}
    </div>
  )
}
